import RestartAltIcon from "@mui/icons-material/RestartAlt";
import { Fab, Portal, Tooltip } from "@mui/material";
import React, { useState } from "react";

import { LocalStorageConfigs } from "../../../../utils/LocalStorage";
import { IStepWrapperButtonProps } from "../../Components/StepWrapper";
import MedicalWireframePicker from "../Components/MedicalWireframePicker";
import MedicalUxVersion from "../Types/MedicalUxVersion";
import ComposedAllMedicalQuestionsStep from "./ComposedAllMedicalQuestionsStep";
import ComposedAutoScrollMedicalStep from "./ComposedAutoScrollMedicalStep";
import ComposedCheckboxOptInMedicalStep from "./ComposedCheckboxOptInMedicalStep";
import ComposedNoToAllMedicalStep from "./ComposedNoToAllMedicalStep";
import ComposedOneAtATimeMedicalStep from "./ComposedOneAtATimeMedicalStep";

const uxVersionComponents: Record<MedicalUxVersion, React.FC<IStepWrapperButtonProps>> = {
  [MedicalUxVersion.CombinedPage]: ComposedAllMedicalQuestionsStep,
  [MedicalUxVersion.OneAtATime]: ComposedOneAtATimeMedicalStep,
  [MedicalUxVersion.AutoScroll]: ComposedAutoScrollMedicalStep,
  [MedicalUxVersion.CheckboxOptIn]: ComposedCheckboxOptInMedicalStep,
  [MedicalUxVersion.NoToAll]: ComposedNoToAllMedicalStep
};

const handleReset = () => {
  localStorage.removeItem(LocalStorageConfigs.medicalForm.key);
  localStorage.removeItem(LocalStorageConfigs.medicalConclusions.key);
  window.location.reload();
};

/** Decorator for the medical step that renders a wireframe UX picker on every page load.
 * Once a version is selected the matching step component is rendered in its place for the current session.
 * Wrap removal: replace this component with ComposedAllMedicalQuestionsStep at the app/medical route.
 */
const ComposedMedicalWireframePickerStep: React.FC<IStepWrapperButtonProps> = props => {
  const [selectedVersion, setSelectedVersion] = useState<MedicalUxVersion | null>(null);

  if (selectedVersion !== null) {
    const SelectedStep = uxVersionComponents[selectedVersion];
    return (
      <>
        <SelectedStep {...props} />
        <Portal>
          <Tooltip title="Reset answers and pick a different experience" placement="left">
            <Fab
              size="small"
              color="secondary"
              onClick={handleReset}
              sx={{ position: "fixed", bottom: 16, right: 16, zIndex: 1300 }}
            >
              <RestartAltIcon />
            </Fab>
          </Tooltip>
        </Portal>
      </>
    );
  }

  return <MedicalWireframePicker onSelect={setSelectedVersion} />;
};

export default ComposedMedicalWireframePickerStep;
